import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { TmActor } from '../../models/tmActor.ts';

interface TmActorState {
  tmActors: TmActor[];
  selectedTmActor: TmActor | null;
}

const initialState: TmActorState = {
  tmActors: [],
  selectedTmActor: null,
};

const tmActorSlice = createSlice({
  name: 'tmActor',
  initialState,
  reducers: {
    setTmActors(state, action: PayloadAction<TmActor[]>) {
      state.tmActors = action.payload;
    },
    addTmActor(state, action: PayloadAction<TmActor>) {
      state.tmActors.push(action.payload);
    },
    updateTmActor(state, action: PayloadAction<TmActor>) {
      const index = state.tmActors.findIndex((a: TmActor) => a.id === action.payload.id);
      if (index !== -1) state.tmActors[index] = action.payload;
    },
    removeTmActor(state, action: PayloadAction<number>) {
      state.tmActors = state.tmActors.filter((a: TmActor) => a.id !== action.payload);
    },
    setSelectedTmActor(state, action: PayloadAction<TmActor | null>) {
      state.selectedTmActor = action.payload;
    },
  },
});

export const { setTmActors, addTmActor, updateTmActor, removeTmActor, setSelectedTmActor } = tmActorSlice.actions;
export const selectTmActors = (state: RootState) => state.tmActor.tmActors;
export const selectSelectedTmActor = (state: RootState) => state.tmActor.selectedTmActor;
export default tmActorSlice.reducer;

